module.exports = __webpack_public_path__ + "assets/744e9195f563465b687ab6b1a6cb33ec.woff2";